'use strict';

var compare = require('../product/compare');

// Removed Sizeguide js file from this page as it is already added in main js
var exportDetails = $.extend({}, compare, {});

const mediaQuery = window.matchMedia('(max-width: 1023.98px)');

$(document).ready(function () {
    if (!$('.seo-rich-content').hasClass('read-more-content')) {
        $('.seo-rich-content a').addClass('seo-content-links');
    }
});

/**
 * Function to add Read more link to Top SEO content if the content exceeds 2 lines
 * @param {JQuery} $ele - DOM element for SEO text
 */
function styleSEOContent($ele) {
    for (var i = 0; i < $ele.length; i++) {
        var lines = $ele[i].getClientRects().length;
        var $seoParent = $ele.parents('.seo-parent');
        if (lines > 2 || (lines <= 2 && $ele.next('h2').length)) {
            if ($ele[0] === $('div.seo-bottom-rich-content')[0]) {
                let headerHeight = $seoParent.find($('.category-title')).outerHeight(true);
                let contentHeight = $seoParent.height();
                $seoParent.css('min-height', headerHeight + contentHeight);
            }
            $seoParent.siblings('.seo-gradient').removeClass('d-none');
            $seoParent.siblings('.expandable-btn-div').find('.showMore').removeClass('d-none');
        }

        if (lines <= 2 && $ele[0] === $('div.seo-bottom-rich-content')[0]) {
            let headerHeight = $seoParent.find($('.category-title')).outerHeight(true);
            let contentHeight = $seoParent.height();
            $seoParent.css('max-height', headerHeight + contentHeight);
        }
    }
}

$(document).ready(function () {
    if ($('p.seo-rich-content')) {
        styleSEOContent($('p.seo-rich-content'));
    }
    if ($('div.seo-bottom-rich-content')) {
        styleSEOContent($('div.seo-bottom-rich-content'));
    }
});

$(document).on('click', '.seo-expandable', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $parentSelector = $(this).parent().siblings('.seo-parent');
    var $gradient = $(this).parent().siblings('.seo-gradient');
    if (!$parentSelector.hasClass('expanded')) {
        $parentSelector.addClass('expanded');
        $gradient.hide();
        $(this).addClass('d-none').attr('aria-hidden', 'true').attr('tabindex', '-1');
        $(this).siblings('.showLess').removeClass('d-none')
        .attr('aria-hidden', 'false')
        .attr('tabindex', '1');
    } else {
        $parentSelector.removeClass('expanded');
        $gradient.show();
        $(this).addClass('d-none').attr('aria-hidden', 'true').attr('tabindex', '-1');
        $(this).siblings('.showMore').removeClass('d-none')
        .attr('aria-hidden', 'false')
        .attr('tabindex', '1');
    }
});

// Initialize CDP recommender carousel on page load.
$(window).on('load', function () {
    if ($('.recommendations-cdp').length) {
        var carouselInit = require('../components/recommendationCarousel');
        var productTile = require('../components/productTile');
        var counter = 0;
        var timer = setInterval(function () {
            if ($('.recommendations-cdp .carousel-container .recommendations').length) {
                var $swatches = $('.recommendations-cdp .swatches');
                carouselInit.initProductCarousel();
                productTile.initSwatch($swatches);
                clearInterval(timer);
            }
            counter++;
            if (counter === 15) {
                clearInterval(timer);
            }
        }, 800);
    }

    var filterItems = document.getElementById('product-search-results');

    /**
     * Keyboard stuff
     * @param {Object} keyVent - key reference
     */
    function keyboardFilterSelectHandler(keyVent) {
        var target = keyVent.target;
        var which = keyVent.which;

        if (which === 13) { // Enter
            $(target).off('click').trigger('click');
            if (mediaQuery.matches) {
                if ($(target).hasClass('filter-results')) {
                    if ($('.active-filter-list li:not(.d-none)').length > 0) {
                        $('.active-filter-list li:not(.d-none) a')[0].focus();
                    } else {
                        $('.card-header.title.title-js:not(.d-none)')[0].focus();
                    }
                }
            }
        } else if (which === 27) { // ESCAPE
            if (mediaQuery.matches && $('.refinement-bar').hasClass('show')) {
                $('.refinements button.close')[0].click();
                $('button.filter-results')[0].focus();
            }
        }
    }

    $(filterItems).on('keydown', '.card-header.title-js, button.filter-results', keyboardFilterSelectHandler);

    /**
     * Aria labels update
     * @param {Object} keyVent - key reference
     */
    function updateAriaLabels() {
        $('.strike-through .value').each(function () {
            var originalAriaLabel = $(this).find('del').attr('aria-label');
            var delValue = $(this).find('del').text().trim();

            if (delValue) {
                var updatedAriaLabel = `${originalAriaLabel} ${delValue}`;
                $(this).attr('aria-label', updatedAriaLabel);
            }
        });
    }
    $(document).ready(function () {
        updateAriaLabels();
    });

    $(document).ajaxComplete(function () {
        updateAriaLabels();
    });

     /**
     * Navigation Aria labels update
     * @param {Object} keyVent - key reference
     */
    function updateAriaAttributes() {
        $('.nav-link').each(function () {
            var $this = $(this);
            if ($this.hasClass('selected')) {
                $this.attr('aria-selected', 'true');
            } else {
                $this.attr('aria-selected', 'false');
            }
        });
    }

    updateAriaAttributes();

    $(document).on('ajaxComplete', function () {
        updateAriaAttributes();
    });

    $('.nav-link').on('click', function () {
        $('.nav-link').removeClass('selected highlighted');
        $(this).addClass('selected highlighted');
        updateAriaAttributes();
    });
});

module.exports = exportDetails;
